import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/encuesta`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchEncuestas = async (params, forcestats) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  if (forcestats) {
    query.set("forcestats", "true");
  }

  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchEncuesta = async (itemId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${itemId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchEncuestaCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("categories"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchEncuesta = async (itemId, encuesta) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encuesta),
  });

  res = await parseJSON(res);

  return res.success;
};
